import { render, staticRenderFns } from "./RealityGlyphCreationModal.vue?vue&type=template&id=87e0359e&scoped=true&"
import script from "./RealityGlyphCreationModal.vue?vue&type=script&lang=js&"
export * from "./RealityGlyphCreationModal.vue?vue&type=script&lang=js&"
import style0 from "./RealityGlyphCreationModal.vue?vue&type=style&index=0&id=87e0359e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e0359e",
  null
  
)

export default component.exports